module.exports = "/layout/app/images/bg-section-veello-theme-insights-before.a0779217.svg";